export const highlightMatches = (inputString: string, searchTerm: string) => {
  if (!searchTerm) return [{ value: inputString }];
  const regex = new RegExp(searchTerm, 'gi');
  const parts = inputString.split(regex);
  let elements: { match?: boolean; value: string }[] = [];

  parts.forEach((part, index) => {
    if (index > 0) {
      const match = inputString.slice(
        inputString.indexOf(parts[index - 1]) + parts[index - 1].length,
        inputString.indexOf(parts[index - 1]) +
          parts[index - 1].length +
          searchTerm.length
      );
      elements.push({ match: true, value: match });
    }

    if (part) elements.push({ value: part });
  });

  return elements;
};
